export class SolicitudFacturacionMasiva {
   emisorId: string;
   tipoDteId: string;
   sucursalId: string;
   cantidadSolicitada: number;
   codigoSii: number;
   tipoArchivo: number;
   usuarioId: string;
}
